// GENERATED FILE - DO NOT MODIFY

export enum GetVenuesSortColumnDto {
    Name = "Name",
    Price = "Price",
    Inventory = "Inventory",
}